/**
 * Collection of validation patterns used across the application.
 * Contains regular expressions for form field validation including names and phone numbers.
 */

/**
 * Collection of validation patterns used across the application.
 *
 * @remarks Provides reusable regular expression patterns for common form validation
 * scenarios. These patterns are used with Angular's pattern validator to ensure
 * data integrity and proper formatting of user inputs.
 *
 */
export const VALIDATION_PATTERNS = {
  /**
   * Pattern for validating names (letters, umlauts, spaces, hyphens).
   *
   * @remarks Accepts German characters including umlauts (ä, ö, ü, ß),
   * standard letters (a-z, A-Z), spaces, and hyphens. Used for first names,
   * last names, and other name-related fields.
   *
   */
  namePattern: /^[a-zA-ZäöüÄÖÜß\s\-]+$/,

  /**
   * Pattern for validating German phone numbers.
   *
   * @remarks Accepts phone numbers starting with +49 (international format)
   * or 0 (national format), followed by 5-20 digits, spaces, hyphens, or slashes.
   * Covers most common German phone number formats.
   *
   */
  phonePattern: /^(\+49|0)[0-9\s\-\/]{5,20}$/,
};
